import { convertStringToMS } from './convertStringToMS';

export function getSessionExpiry() {
  const now = new Date();
  return new Date(now.setMilliseconds(convertStringToMS('30d')));
}
